import { PageHeader } from './PageHeader';

/**
 * A route that resolves to nothing — ADMIN-11 gave it the console's own heading.
 *
 * It used to render its own `<main>`, nested inside the one `AppShell` renders. Two
 * `<main>` elements is one landmark too many, and this is the screen a lost reader
 * lands on.
 */
export function NotFound() {
  return <PageHeader title="Not found" />;
}
